// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Client from "@apollo/client";
import * as ApolloClient__Cache_Core_Cache from "../core/ApolloClient__Cache_Core_Cache.bs.js";
import * as ApolloClient__Cache_InMemory_Policies from "./ApolloClient__Cache_InMemory_Policies.bs.js";

var Js_ = {};

function make(prim0, prim1, prim2, prim3, prim4, prim5) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.resultCaching = Caml_option.valFromOption(prim0);
  }
  if (prim1 !== undefined) {
    tmp.possibleTypes = Caml_option.valFromOption(prim1);
  }
  if (prim2 !== undefined) {
    tmp.typePolicies = Caml_option.valFromOption(prim2);
  }
  if (prim3 !== undefined) {
    tmp.dataIdFromObject = Caml_option.valFromOption(prim3);
  }
  if (prim4 !== undefined) {
    tmp.addTypename = Caml_option.valFromOption(prim4);
  }
  return tmp;
}

var InMemoryCacheConfig = {
  Js_: Js_,
  make: make
};

var Js_$1 = {};

function make$1(addTypename, dataIdFromObject, possibleTypes, resultCaching, typePolicies, param) {
  return ApolloClient__Cache_Core_Cache.ApolloCache.fromJs(new Client.InMemoryCache(make(resultCaching, possibleTypes, Belt_Option.map(typePolicies, ApolloClient__Cache_InMemory_Policies.TypePolicies.toJs), dataIdFromObject, addTypename, undefined)));
}

var ApolloCache;

var KeyFieldsFunction;

var PossibleTypesMap;

var TypePolicy;

var TypePolicies;

export {
  ApolloCache ,
  KeyFieldsFunction ,
  PossibleTypesMap ,
  TypePolicy ,
  TypePolicies ,
  InMemoryCacheConfig ,
  Js_$1 as Js_,
  make$1 as make,
  
}
/* @apollo/client Not a pure module */
